export default __webpack_public_path__ + "static/media/Banner_CONOCELES-EDITABLE-02.cf75b6c0.png";